import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import Modal, { useModalManager, Footer } from 'common/Modal';
import { initClipboard } from 'ClipboardButton';
import { TCITooltip } from '@/components/ui/Tooltip';
import Icon from '@/components/ui/Icon';
import ShareToGoogleClassroom from '../ShareToGoogleClassroom';
import CopyToClipboardField from './CopyToClipboardField';
import styles from './index.module.scss';

const LmsShare = ({
  disabled,
  ...props
}) => {
  const modalManager = useModalManager();

  useEffect(initClipboard, []);

  const googleClassroomField = (
    <div className={styles.row}>
      <p className={styles.fieldContainer}>{`1. ${I18n.t('share_to_google_classroom')}`}</p>
      <ShareToGoogleClassroom className={styles.shareToGoogleButton} url={props.googleClassroomUrl} />
    </div>
  );

  const shareableLinkField = (
    <CopyToClipboardField
      copyText={props.shareableResourceUrl}
      id="share-link"
      label={`2. ${I18n.t('shareable_link')}`}
    />
  );

  const ltiLinkField = (
    <CopyToClipboardField
      copyText={props.ltiResourceUrl}
      id="lti-link"
      label={`3. ${I18n.t('lti_link')}`}
    />
  );

  return (
    <React.Fragment>
      <TCITooltip side="bottom">
        <TCITooltip.Trigger asChild>
          <button
            aria-controls="shareModal"
            aria-disabled={disabled}
            aria-haspopup="dialog"
            aria-label={I18n.t('share')}
            className={`${styles.icon} ${disabled && styles.disabled} !tw-m-0`}
            type="button"
            onClick={disabled ? undefined : modalManager.open}
          >
            <Icon className={disabled ? 'tw-text-very-dark-grey' : 'tw-text-tci-purple'} icon="ShareLink" size={30} />
            <span className="sr-only">{I18n.t('sharing_options')}</span>
          </button>
        </TCITooltip.Trigger>
        <TCITooltip.Content>
          {disabled ? I18n.t('no_access_to_lesson') : I18n.t('share')}
        </TCITooltip.Content>
      </TCITooltip>

      <Modal
        aria-labelledby="Sharing Options"
        aria-modal="true"
        className={styles.lmsShareModal}
        closeModal={modalManager.close}
        headerText={I18n.t('sharing_options')}
        id="shareModal"
        isOpen={modalManager.isOpen}
        role="dialog"
      >
        <div className={styles.lmsShareModalBody}>
          {googleClassroomField}
          {shareableLinkField}
          {props.ltiResourceUrl && ltiLinkField}
        </div>

        <Footer
          primaryButtonCallback={modalManager.close}
          primaryButtonSubmit={false}
          primaryButtonText={I18n.t('done')}
          secondaryButtonCallback={modalManager.close}
          secondaryButtonText={I18n.t('cancel')}
        />
      </Modal>
    </React.Fragment>
  );
};

LmsShare.propTypes = {
  disabled: PropTypes.bool,
  googleClassroomUrl: PropTypes.string,
  ltiResourceUrl: PropTypes.string,
  shareableResourceUrl: PropTypes.string,
};

LmsShare.defaultProps = {
  disabled: false,
  googleClassroomUrl: null,
  ltiResourceUrl: null,
  shareableResourceUrl: null,
};

export default LmsShare;
